import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigFormScreen } from './ConfigFormScreen';
import { useOgCutoff, useUpdateOgCutoff } from '@/api/opengater/useSettings';
/**
 * users `admin: subscription-cutoff` — time of day until which a subscription counts
 * as paid for the current day. Must stay later than the daily charge job.
 */
export function OpengaterCutoff() {
    const q = useOgCutoff();
    const upd = useUpdateOgCutoff();
    return (_jsx(ConfigFormScreen, { title: "\u041A\u043E\u043D\u0435\u0446 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043D\u044F", subtitle: "\u0414\u043E \u043A\u0430\u043A\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u043E\u0439 \u0437\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0434\u0435\u043D\u044C", capability: "subscription-cutoff.write", sections: [
            {
                title: 'Ежедневно в',
                fields: [
                    {
                        key: 'cutoff_hour',
                        label: 'Час',
                        kind: 'int',
                        min: 0,
                        max: 23,
                        hint: 'Позже времени списания.',
                    },
                    { key: 'cutoff_minute', label: 'Минута', kind: 'int', min: 0, max: 59 },
                ],
            },
        ], data: q.data, isLoading: q.isLoading, error: q.error, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
